import { SelectFieldProps } from "components/Form/typings";
import MultiSelect from "components/Form/Select/MultiSelect";
import FormField from "../FormField";

export default function MultiSelectField({
  name,
  label,
  placeholder,
  control,
  options,
  errors,
  required,
  menuPlacement,
  variant,
  isClearable = false,
  formFieldProps = {},
}: SelectFieldProps & { menuPlacement?: "auto" | "top" | "bottom" }) {
  const formVariant = variant;
  return (
    <FormField name={name} label={label} errors={errors} required={required} variant={formVariant} {...formFieldProps}>
      <MultiSelect
        name={name}
        control={control}
        menuPlacement={menuPlacement}
        placeholder={formVariant === "floating" ? " " : placeholder}
        options={options}
        isClearable={isClearable}
      />
    </FormField>
  );
}
